export interface ContentProps {
  open: boolean;
  closeModal: () => void;
  miles: string;
  tierMilage: string;
}
export enum ModalTypes {
  confirmation = 'confirmation',
  success = 'success',
}
